import cogoToast from 'cogo-toast';
import { TOAST_POSITION } from '../../helpers/config';
const { createSlice } = require('@reduxjs/toolkit');

const compareSlice = createSlice({
    name: "compare",
    initialState: {
        compareItems: []
    },
    reducers: {
        addToCompare(state, action) {
            state.compareItems.push(action.payload);
            cogoToast.success("Added To compare", {position: TOAST_POSITION, hideAfter: 5});
        },
        deleteFromCompare(state, action){
            state.compareItems = state.compareItems.filter(item => item.id !== action.payload);
            cogoToast.error("Removed From Compare", {position: TOAST_POSITION, hideAfter: 5});
        }
    },
});

export const { addToCompare, deleteFromCompare } = compareSlice.actions;
export default compareSlice.reducer;
